import React from 'react';
import { ResourceCenter } from 'cccisd-laravel-resources';

const ResourceCenterTab = props => {
    return <ResourceCenter handle="instructors" />;
};

export default ResourceCenterTab;
